import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ListStatusOption } from '../list-kit/list-status-palettes';

/** Captioned status / priority pill; opens a menu when interactive. */
@Component({
  selector: 'app-detail-pill',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span class="pp-dpill">
      <span *ngIf="caption" class="pp-dpill__cap">{{ caption }}</span>
      <button
        *ngIf="interactive; else staticPill"
        type="button"
        class="pp-inline-pill"
        [ngClass]="pillClass"
        [attr.aria-label]="(caption ? caption + ': ' : '') + text"
        (click)="open.emit($event)">
        {{ text }}
        <i class="pi pi-angle-down"></i>
      </button>
      <ng-template #staticPill>
        <span class="pp-inline-pill pp-inline-pill--static" [ngClass]="pillClass">{{ text }}</span>
      </ng-template>
    </span>
  `,
  styles: [':host { display: inline-flex; }'],
})
export class DetailPillComponent {
  @Input() caption = '';
  @Input() option: ListStatusOption | null | undefined = null;
  /** Shown when the value has no palette entry. */
  @Input() fallback: string | null | undefined = '';
  /** Overrides the palette class, e.g. `pp-inline-pill--success`. */
  @Input() tone = '';
  @Input() interactive = false;
  @Output() open = new EventEmitter<MouseEvent>();

  get text(): string {
    return this.option?.label || this.fallback || '—';
  }

  get pillClass(): string {
    return this.tone || this.option?.className || 'pp-inline-pill--slate';
  }
}
